import Marquee from "react-fast-marquee";
import { CLIENTS } from "@/data/site";

export function ClientsMarquee() {
  return (
    <section className="border-y border-white/5 bg-surface/30 py-8" data-testid="clients-marquee">
      <p className="mb-6 text-center font-mono text-xs uppercase tracking-[0.3em] text-muted">
        Brands we've grown across marketplaces
      </p>
      <Marquee speed={40} gradient gradientColor="#0B0814" gradientWidth={120} pauseOnHover>
        {CLIENTS.map((c, i) => (
          <span
            key={i}
            className="mx-10 font-display text-2xl font-semibold text-white/25 transition-colors hover:text-white/70"
          >
            {c}
          </span>
        ))}
      </Marquee>
    </section>
  );
}
